import React from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../../components/Hero';
import Features from '../../components/Features';
import DashboardShowcase from '../../components/DashboardShowcase';
import HowItWorks from '../../components/HowItWorks';
import UseCases from '../../components/UseCases';
import Stats from '../../components/Stats';
import Footer from '../../components/Footer';

export default function Home() {
  return (
    <div>
      <Navbar />
      <Hero />
      <DashboardShowcase autoRotate={true} rotationInterval={5000} />
      <Features />
      <HowItWorks />
      <UseCases />
      <Stats />
      <Footer />
    </div>
  );
}

